import { PredictionSummaryData } from "../types";
import DecisionBadge from "./decisionBadge";
import SummaryFieldRow from "./summaryFieldRow";

/**
 * Props for the Summary tab content.
 */
interface SummaryTabProps {
  /** Evaluation engine payload to display. */
  data: PredictionSummaryData;
}

/**
 * Summary tab matching the Evaluation Engine Output design (label/value rows).
 *
 * @param props.data - Prediction summary payload
 */
const SummaryTab = (props: SummaryTabProps) => {
  const { data } = props;

  return (
    <div className="prediction-summary-modal__summary flex flex-col">
      <SummaryFieldRow label="CMM Key:">{data.cmm_key}</SummaryFieldRow>
      <SummaryFieldRow label="Drug:">{data.drug}</SummaryFieldRow>
      <SummaryFieldRow label="Decision:">
        <DecisionBadge decision={data.decision} />
      </SummaryFieldRow>
      <SummaryFieldRow label="Confidence:">
        <span className="rounded bg-tertiaryBlue-12 px-2 py-1 text-tiny font-semibold text-tertiaryBlue-4">
          {data.confidence}%
        </span>
      </SummaryFieldRow>
      <SummaryFieldRow label="Plan:">{data.plan}</SummaryFieldRow>
      <SummaryFieldRow label="Form:">{data.form}</SummaryFieldRow>
      <SummaryFieldRow label="Rationale:">{data.rationale}</SummaryFieldRow>
      <SummaryFieldRow label="Confidence Basis:" isLast>
        {data.confidence_basis}
      </SummaryFieldRow>
    </div>
  );
};

export default SummaryTab;
